var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.$style.wrapper,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_c('i',{staticClass:"icon icon-question"})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }